import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-row justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-right":"20px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon-lg icon-success",
    "aria-label": "Appuntamento confermato"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      href: "/bi-sprites.svg#it-check-circle",
      "xlink:href": "/bi-sprites.svg#it-check-circle"
    })
  ])
], -1)
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-12 text-center" }
const _hoisted_5 = { class: "h6" }
const _hoisted_6 = { class: "row justify-content-center mt-4 summary-book-data" }
const _hoisted_7 = { class: "col-12 sm-10 col-md-8 col-xl-6 d-grid gap-2" }
const _hoisted_8 = {
  class: "section",
  style: {"background":"#f8f8f8","padding":"20px"},
  "aria-describedby": "titleYourBooking"
}
const _hoisted_9 = { class: "section-content" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "d-flex justify-content-start" }
const _hoisted_12 = {
  class: "text-uppercase h6",
  id: "titleYourBooking",
  style: {"font-weight":"bold"}
}
const _hoisted_13 = { class: "row mt-4" }
const _hoisted_14 = { class: "d-flex justify-content-start" }
const _hoisted_15 = { style: {"margin-bottom":"0px"} }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "d-flex justify-content-start" }
const _hoisted_18 = { style: {"font-size":"20px","text-align":"left","font-weight":"bold"} }
const _hoisted_19 = { class: "row mt-4" }
const _hoisted_20 = { class: "d-flex justify-content-start" }
const _hoisted_21 = { style: {"margin-bottom":"0px"} }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "d-flex justify-content-start" }
const _hoisted_24 = { style: {"font-size":"20px","font-weight":"bold"} }
const _hoisted_25 = { class: "row mt-4" }
const _hoisted_26 = { class: "d-flex justify-content-start" }
const _hoisted_27 = { style: {"margin-bottom":"0px"} }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "d-flex justify-content-start" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_32 = { class: "d-flex justify-content-start" }
const _hoisted_33 = { style: {"margin-bottom":"0px"} }
const _hoisted_34 = {
  key: 1,
  class: "row"
}
const _hoisted_35 = { class: "d-flex justify-content-start" }
const _hoisted_36 = { style: {"font-size":"20px","font-weight":"bold"} }
const _hoisted_37 = {
  key: 0,
  class: "row justify-content-center mt-4"
}
const _hoisted_38 = { class: "col-12 sm-10 col-md-8 col-xl-6 d-grid gap-2" }
const _hoisted_39 = {
  class: "section",
  style: {"background":"#f8f8f8","padding":"20px"},
  "aria-describedby": "titleRequestedDocuments"
}
const _hoisted_40 = { class: "section-content" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "d-flex justify-content-start" }
const _hoisted_43 = {
  class: "text-uppercase h6",
  id: "titleRequestedDocuments",
  style: {"font-weight":"bold"}
}
const _hoisted_44 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_45 = ["href"]
const _hoisted_46 = { class: "row mt-4 it-list-wrapper" }
const _hoisted_47 = { class: "it-list" }
const _hoisted_48 = {
  class: "list-item align-items-start pb-3",
  style: {"border-bottom":"unset !important"}
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "it-rounded-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    "aria-label": "Aggiungi ad iCloud"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      href: "/bi-sprites.svg#it-arrow-right-triangle",
      "xlink:href": "/bi-sprites.svg#it-arrow-right-triangle"
    })
  ])
], -1)
const _hoisted_50 = { class: "it-right-zone py-0" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "row justify-content-center mt-4" }
const _hoisted_53 = { class: "col-12 sm-10 col-md-8 col-xl-6 d-grid gap-2" }
const _hoisted_54 = { class: "row" }
const _hoisted_55 = { class: "d-flex justify-content-center" }
const _hoisted_56 = { id: "addToCalendar" }
const _hoisted_57 = { class: "row mt-2 it-list-wrapper" }
const _hoisted_58 = {
  class: "it-list",
  style: {"cursor":"pointer"}
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "it-rounded-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    "aria-label": "Aggiungi a Outlook"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      href: "/bi-sprites.svg#it-calendar",
      "xlink:href": "/bi-sprites.svg#it-calendar"
    })
  ])
], -1)
const _hoisted_60 = { class: "it-right-zone" }
const _hoisted_61 = { class: "text" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "it-rounded-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    "aria-label": "Aggiungi a Google Calendar"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      href: "/bi-sprites.svg#it-calendar",
      "xlink:href": "/bi-sprites.svg#it-calendar"
    })
  ])
], -1)
const _hoisted_63 = { class: "it-right-zone" }
const _hoisted_64 = { class: "text" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "it-rounded-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    "aria-label": "Aggiungi ad iCloud"
  }, [
    /*#__PURE__*/_createElementVNode("use", {
      href: "/bi-sprites.svg#it-calendar",
      "xlink:href": "/bi-sprites.svg#it-calendar"
    })
  ])
], -1)
const _hoisted_66 = { class: "it-right-zone" }
const _hoisted_67 = { class: "text" }

import { useStore } from "@/models/Store/store";
import _ from "lodash";
import moment from "moment";
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useTenantConfig } from "../../composables/useTenantConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Summary',
  setup(__props) {

const { t } = useI18n();
const store = useStore();
const { webPriorityChannel } = useTenantConfig();

const notificationText = computed(() => {
    let notificationChannelText = "";
    switch (webPriorityChannel.value) {
        case "email":
            notificationChannelText = t("common.anEmail");
            break;
        case "sms":
            notificationChannelText = t("common.aSms");
            break;
        case "email_sms":
            notificationChannelText = t("common.anEmailAndSms");
            break;
        case "email_o_sms":
            notificationChannelText = t("common.anEmailOrSms");
            break;
        case "sms_o_email":
            notificationChannelText = t("common.anEmailOrSms");
            break;
        default:
            notificationChannelText = t("common.aNotification");
            break;
    }
    return t("messages.bookingSuccessNotification").replace("##NotificationText##", notificationChannelText);
});

const serviceFromBooking = computed(() => {
    const servicesArray = store.bookingSubmitted.slots.map((item) => {
        return item.service.name;
    });

    const services = _.uniq(servicesArray);
    return services.join(", ");
});

const encodeHTML = (text: string) => {
  return text
    .replace(/ì/g, '&igrave;');
};

const dateFromBooking = computed(() => {
    if (store.bookingSubmitted.slots && store.bookingSubmitted.slots[0]) {
        return encodeHTML(`${moment(store.bookingSubmitted.slots[0].fromDate).format("dddd DD MMMM YYYY")} ore ${moment(store.bookingSubmitted.slots[0].fromDate).format("HH:mm")}`);
    } else return "";
});

const documentsFromBooking = computed(() => {
    const documents: string[] = [];
    for (let index = 0; index < store.bookingSubmitted.slots.length; index++) {
        const item = store.bookingSubmitted.slots[index];
        if (item.service.serviceInfo) {
            var docs = item.service.serviceInfo.split("|");

            for (var j = 0; j < docs.length; j++) {
                if (
                    documents.some(function (item) {
                        return item == docs[j];
                    }) == false
                ) {
                    documents.push(docs[j]);
                }
            }
        }
    }
    return documents;
});

const existsDocumentsLink = computed(() => {
    if((t("common.requestedDocumentsLinkText") != 'common.requestedDocumentsLinkText' && t("common.requestedDocumentsLinkText").length > 0) && (t("common.requestedDocumentsLink") != 'common.requestedDocumentsLink' && t("common.requestedDocumentsLink").length > 0)){
        return true;
    }
    else{
        return false;
    }
});

onMounted(() => {
    const localeCode = t("settings.localeCode");
    moment.locale(localeCode);
});

const addEventOnCalendariCloud = () => {
    let now = moment().format("YYYYMMDDTHHmmSS") + "Z";
    let startDate = moment(store.bookingSubmitted.slots[0].fromDate).format("YYYYMMDDTHHmmSS") + "Z";
    let toDate = moment(store.bookingSubmitted.slots[0].toDate).format("YYYYMMDDTHHmmSS") + "Z";

    let subject = "Appuntamento: " + serviceFromBooking.value;
    let body = "";
    if (documentsFromBooking.value && documentsFromBooking.value.length) {
        body = "<div>Documenti necessari:</div><ul>";

        for (var i = 0; i < documentsFromBooking.value.length; i++) {
            body += `<li>${documentsFromBooking.value[i]}</li>`;
        }

        body += "</ul>";
    }

    let appUrl = window.location.origin;

    var icsMSG = "BEGIN:VCALENDAR\nVERSION:2.0\r\n";
    icsMSG += `PRODID:-// ${appUrl} //NONSGML v1.0//IT\r\n`;
    icsMSG += "BEGIN:VEVENT\r\n";
    icsMSG += "UID:me@google.com\r\n";
    icsMSG += `DTSTAMP:${now}\r\n`;
    icsMSG += `DTSTART:${startDate}\r\n`;
    icsMSG += `DTEND:${toDate}\r\n`;
    icsMSG += `SUMMARY:${subject}\r\n`;
    if (body) {
        icsMSG += `DESCRIPTION:Documenti necessari: ${documentsFromBooking.value.join(", ")}\r\n`;

        icsMSG += `X-ALT-DESC;FMTTYPE=text/html:
        <!DOCTYPE HTML PUBLIC ""-//W3C//DTD HTML 3.2//IT"">
        <HTML><BODY>
        ${body}
        </BODY></HTML>
        SEQUENCE:0
        STATUS:CONFIRMED\r\n`;
    }
    icsMSG += `END:VEVENT\r\nEND:VCALENDAR`;
    var title = "newEvent.ics";
    var uri = "data:text/calendar;charset=utf8," + escape(icsMSG);

    let link = document.createElement("a");
    link.href = uri;
    link.download = title;
    link.target = "_BLANK";
    link.click();
    URL.revokeObjectURL(link.href);
};

const addEventOnCalendarGoogle = () => {
    let startDate = moment(store.bookingSubmitted.slots[0].fromDate).format("YYYYMMDDTHHmmSS");
    let toDate = moment(store.bookingSubmitted.slots[0].toDate).format("YYYYMMDDTHHmmSS");

    let subject = "Appuntamento: " + serviceFromBooking.value;
    let body = "";
    if (documentsFromBooking.value && documentsFromBooking.value.length) {
        body = "&details=<div>Documenti necessari:</div><ul>";

        for (var i = 0; i < documentsFromBooking.value.length; i++) {
            body += `<li>${documentsFromBooking.value[i]}</li>`;
        }

        body += "</ul>";
    }
    let urlGoogle = `https://calendar.google.com/calendar/u/0/r/eventedit?dates=${startDate}/${toDate}&ctz=Europe/Rome&text=${subject}${body}`;

    let link = document.createElement("a");
    link.href = urlGoogle;
    link.download = "prenotazione";
    link.target = "_BLANK";
    link.click();
    URL.revokeObjectURL(link.href);
};

const addEventOnCalendarOutlook = () => {
    let startDate = moment(store.bookingSubmitted.slots[0].fromDate).utc().format();
    let toDate = moment(store.bookingSubmitted.slots[0].toDate).utc().format();

    let subject = "Appuntamento: " + serviceFromBooking.value;
    let body = "";
    if (documentsFromBooking.value && documentsFromBooking.value.length) {
        body = "&body=<div>Documenti necessari:</div><ul>";

        for (var i = 0; i < documentsFromBooking.value.length; i++) {
            body += `<li>${documentsFromBooking.value[i]}</li>`;
        }

        body += "</ul>";
    }
    let urlOutlook = `https://outlook.live.com/calendar/action/compose?rru=addevent&startdt=${startDate}&enddt=${toDate}&subject=${subject}${body}`;

    let link = document.createElement("a");
    link.href = urlOutlook;
    link.download = "prenotazione";
    link.target = "_BLANK";
    link.click();
    URL.revokeObjectURL(link.href);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("messages.bookingSuccess")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(notificationText.value), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("section", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(t)("titles.yourBooking")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("titles.stepperServiceShort")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(serviceFromBooking.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("titles.stepperLocationShort")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", _hoisted_24, _toDisplayString(_unref(store).bookingSubmitted.room.location.name), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(t)("titles.stepperHourShort")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("p", {
                  style: {"font-size":"20px","font-weight":"bold"},
                  innerHTML: dateFromBooking.value
                }, null, 8, _hoisted_30)
              ])
            ]),
            (_unref(store).bookingSubmitted.notes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_unref(t)("common.notes")), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_unref(store).bookingSubmitted.notes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("p", _hoisted_36, _toDisplayString(_unref(store).bookingSubmitted.notes), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (documentsFromBooking.value && documentsFromBooking.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("section", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("h3", _hoisted_43, _toDisplayString(_unref(t)("common.requestedDocumentsSummary")), 1)
                  ])
                ]),
                (existsDocumentsLink.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _createElementVNode("h6", null, [
                        _createElementVNode("a", {
                          href: _unref(t)('common.requestedDocumentsLink'),
                          target: "_blank"
                        }, _toDisplayString(_unref(t)("common.requestedDocumentsLinkText")), 9, _hoisted_45)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("ul", _hoisted_47, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentsFromBooking.value, (doc, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, [
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("span", {
                              innerHTML: doc,
                              class: "text",
                              style: {"font-weight":"500"}
                            }, null, 8, _hoisted_51)
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_52, [
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("div", _hoisted_54, [
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("h3", _hoisted_56, _toDisplayString(_unref(t)("common.addToCalendar")), 1)
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("ul", _hoisted_58, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "list-item",
                  style: {"border-bottom":"unset !important"},
                  href: "#",
                  onClick: _withModifiers(addEventOnCalendarOutlook, ["prevent","stop"])
                }, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, [
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(t)("common.calendarOutlook")), 1)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "list-item",
                  style: {"border-bottom":"unset !important"},
                  href: "#",
                  onClick: _withModifiers(addEventOnCalendarGoogle, ["prevent","stop"])
                }, [
                  _hoisted_62,
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("span", _hoisted_64, _toDisplayString(_unref(t)("common.calendarGoogle")), 1)
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  class: "list-item",
                  style: {"border-bottom":"unset !important"},
                  href: "#",
                  onClick: _withModifiers(addEventOnCalendariCloud, ["prevent","stop"])
                }, [
                  _hoisted_65,
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(t)("common.calendariCloud")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})